import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { gql, useMutation } from '@apollo/client'
import { Typography } from '@mui/material'

import CardActionButton from 'components/global/CardActions/CardActionButton'
import ActionModal from 'components/Modal/ActionModal'
import { useUser } from 'store'
import { trackEvent } from 'analytics'

const OPERATION_REVOKE_USER = gql`
  mutation revokeUser($sf_id: ID!) {
    result: revokeUser(sf_id: $sf_id) {
      status
    }
  }
`
const ModalRevoker = ({contact, onClose}) => {
  const { t } = useTranslation()
  const [revoke, {loading, error}] = useMutation(OPERATION_REVOKE_USER)

  const handleConfirm = async () => {
    const result = await revoke({variables: {sf_id: contact.sf_id}})
    if (!result.error) {
      trackEvent('user_revoked')
      onClose()
    }
  }

  return (
    <ActionModal
      cancelLabel={t('actions.cancel')}
      confirmLabel={t('actions.confirm')}
      description={t('auth.admin.revoke.description')}
      icon={<i className="fa-light fa-power-off" />}
      loading={loading}
      onClose={onClose}
      onConfirm={handleConfirm}
      title={t('auth.admin.revoke.title')}
      variant="warning"
    >
      {Boolean(error) && <Typography color="error" variant="caption">{t('actions.error')}</Typography>}
    </ActionModal>
  )
}
const ActionRevoke = ({ contact }) => {
  const [openModal, setOpenModal] = useState(false)
  const { t } = useTranslation()
  const [user] = useUser()
  return (
    <>
      <CardActionButton
        sx={{
          border: '1px solid #E5E7EB',
          borderRadius: '8px',
          width: '32px',
          height: '32px'
        }}
        iconlabel={'power-off'}
        tooltiptitle={t('auth.admin.revoke.tooltip')}
        onClick={() => {
          if (!user.demo_role) {
            setOpenModal(true)
          }
        }}
      />
      {
        openModal && <ModalRevoker contact={contact} onClose={() => setOpenModal(false)} />
      }
    </>
  )
}

export default ActionRevoke
